export default __webpack_public_path__ + "static/media/normal.c0377e0d.png";